<script>
export default {
    name: 'AuthorizationFieldInfo',
};
</script>

<script setup>
import { computed, ref } from 'vue';
import i18n from '@/plugins/i18n.ts';
import useDocs from '@/composables/useDocs.ts';

const props = defineProps({
    text: {
        type: String,
        required: true,
    },
    faqLink: {
        type: String,
    },
    videoLink: {
        type: String,
    },
    docsSlug: {
        type: String,
    },
});

const showVideo = ref(false);

const moreInfo = computed(() => {
    const params = {
        link: props.faqLink,
    };

    return props.videoLink ? i18n.t('wizard faq more info video', params) : i18n.t('wizard faq more info', params);
});

const { open } = useDocs();
</script>

<template>
    <base-icon
        v-if="docsSlug"
        name="question-circle"
        prefix="far"
        type="info"
        clickable
        @click="open(docsSlug)"
    />
    <base-info
        v-else
        size="small"
        :info="text"
    >
        <span class="text-sm">
            <span v-html="text" />
            <span v-if="faqLink" v-html="moreInfo" />
            <span
                v-if="videoLink"
                class="ml-1"
            >
                <base-icon
                    name="youtube"
                    prefix="fab"
                    :clickable="true"
                    @click="showVideo = true"
                />
                <base-video
                    v-model="showVideo"
                    :link="videoLink"
                />
            </span>
        </span>
    </base-info>
</template>
